var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 3.16669C3.57462 3.16669 3.5 3.24131 3.5 3.33335V14C3.5 14.0921 3.57462 14.1667 3.66667 14.1667H12.3333C12.4254 14.1667 12.5 14.0921 12.5 14V3.33335C12.5 3.24131 12.4254 3.16669 12.3333 3.16669H3.66667ZM2.5 3.33335C2.5 2.68902 3.02233 2.16669 3.66667 2.16669H12.3333C12.9777 2.16669 13.5 2.68902 13.5 3.33335V14C13.5 14.6444 12.9777 15.1667 12.3333 15.1667H3.66667C3.02233 15.1667 2.5 14.6444 2.5 14V3.33335Z",
    fill: "#4952FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.833344C6.27614 0.833344 6.5 1.0572 6.5 1.33334V3.33334C6.5 3.60948 6.27614 3.83334 6 3.83334C5.72386 3.83334 5.5 3.60948 5.5 3.33334V1.33334C5.5 1.0572 5.72386 0.833344 6 0.833344Z",
    fill: "#4952FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.833344C10.2761 0.833344 10.5 1.0572 10.5 1.33334V3.33334C10.5 3.60948 10.2761 3.83334 10 3.83334C9.72387 3.83334 9.5 3.60948 9.5 3.33334V1.33334C9.5 1.0572 9.72387 0.833344 10 0.833344Z",
    fill: "#4952FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83331 6.33334C4.83331 6.0572 5.05717 5.83334 5.33331 5.83334H10.6666C10.9428 5.83334 11.1666 6.0572 11.1666 6.33334C11.1666 6.60948 10.9428 6.83334 10.6666 6.83334H5.33331C5.05717 6.83334 4.83331 6.60948 4.83331 6.33334Z",
    fill: "#4952FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83331 9C4.83331 8.72387 5.05717 8.5 5.33331 8.5H9.33331C9.60945 8.5 9.83331 8.72387 9.83331 9C9.83331 9.27613 9.60945 9.5 9.33331 9.5H5.33331C5.05717 9.5 4.83331 9.27613 4.83331 9Z",
    fill: "#4952FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83331 11.6667C4.83331 11.3906 5.05717 11.1667 5.33331 11.1667H7.99998C8.27611 11.1667 8.49998 11.3906 8.49998 11.6667C8.49998 11.9428 8.27611 12.1667 7.99998 12.1667H5.33331C5.05717 12.1667 4.83331 11.9428 4.83331 11.6667Z",
    fill: "#4952FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.aa5559b7549ac1515faa9902286d400c.svg";
export { ForwardRef as ReactComponent };